module.exports = __webpack_public_path__ + "img/Infografis_ID_19.d1e96c9e.jpg";